(() => {
  'use strict';
  const cfg = window.Cieluxi;
  if (!cfg?.offer?.enabled || cfg.currency !== 'USD') return;
  const single = new Set(['50544255828226','50544255893762','50544255959298']);
  const duo = new Set(['50544255860994','50544255926530','50544255992066']);
  const trio = new Set(['50959422161154','50959422193922','50959422226690']);
  let state = {active:false,codes:[]}, deadline = 0, pending, cartQueue = Promise.resolve();
  let lastCheck = 0;
  const active = () => state.active && performance.now() < deadline;
  const notify = () => document.dispatchEvent(new CustomEvent('spt:offer-change'));
  function render() {
    const on = active();
    document.querySelectorAll('[data-personal-offer]').forEach(box => {
      box.hidden = !state.expiresAt;
      box.querySelector('[data-offer-status]').textContent = on ? cfg.offer.labels.active : cfg.offer.labels.expired;
      box.querySelector('[data-offer-note]').textContent = on ? cfg.offer.labels.note : cfg.offer.labels.regular;
      const timer = box.querySelector('[data-offer-timer]');
      timer.hidden = !on;
      const seconds = Math.max(0,Math.ceil((deadline-performance.now())/1000));
      timer.textContent = [Math.floor(seconds/3600),Math.floor(seconds/60)%60,seconds%60].map(value => String(value).padStart(2,'0')).join(':');
    });
  }
  async function load() {
    if (pending) return pending;
    pending = (async () => {
      try {
        const start = performance.now();
        const endpoint = new URL(cfg.offer.endpoint);
        endpoint.searchParams.set('bundles','3');
        const response = await fetch(endpoint,{cache:'no-store',credentials:'omit',signal:AbortSignal.timeout(15000)});
        const next = await response.json();
        if (!response.ok || !Array.isArray(next.codes)) throw new Error('Offer unavailable');
        if (next.active && (!Number.isFinite(next.serverNow) || !Number.isFinite(next.expiresAt) || next.prices?.single !== 2699 || next.prices?.duo !== 4999 || next.prices?.trio !== 6999 || next.codes.length !== 3 || next.codes.some(code => !/^SPT6H[A-F0-9]{40}[SDT]$/.test(code)))) throw new Error('Invalid offer');
        state = next;
        deadline = start + Math.max(0,(next.expiresAt || 0)-next.serverNow);
      } catch {
        state = {active:false,codes:[]};
        deadline = 0;
      }
      lastCheck = performance.now();
      render();
    })();
    await pending;
    pending = null;
  }
  async function cartJson(path,options) {
    const response = await fetch(cfg.root+path,{credentials:'same-origin',...options});
    if (!response.ok) throw new Error(cfg.labels.error);
    return response.json();
  }
  window.SantaOffer = {
    price(variant) {
      if (!active()) return variant.price;
      return single.has(String(variant.id)) ? 2699 : duo.has(String(variant.id)) ? 4999 : trio.has(String(variant.id)) ? 6999 : variant.price;
    },
    async syncCart(cart) {
      await ready;
      const task = cartQueue.catch(() => {}).then(async () => {
        const current = cart || await cartJson('cart.js');
        const existing = (current.discount_codes || []).map(item => item.code);
        const desired = [...new Set([...existing.filter(code => !/^SPT6H/i.test(code)),...(active()?state.codes:[])])];
        if (existing.slice().sort().join(',') === desired.slice().sort().join(',')) return current;
        return cartJson('cart/update.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({discount:desired.join(',')})});
      });
      cartQueue = task;
      return task;
    }
  };
  const ready = load();
  ready.then(notify);
  setInterval(() => {
    if (state.active && !active()) { state.active = false; render(); notify(); }
    else render();
  },1000);
  document.addEventListener('visibilitychange',() => {
    if (!document.hidden && performance.now()-lastCheck > 60000) load().then(notify);
  });
  document.addEventListener('shopify:section:load',render);
})();

